"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommonModalBehavior = exports.getModalAriaProps = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const ModalOverlay_1 = __importDefault(require("./ModalOverlay"));
const ModalStackContext_1 = require("./ModalStackContext");
const ShadowOverlay_1 = __importDefault(require("./ShadowOverlay"));
function getModalAriaProps(props) {
    const { name, label, title } = props;
    const modalProps = {
        role: 'dialog',
        tabindex: '-1',
        'aria-modal': 'true',
        'data-id': `${name}-modal`,
    };
    const titleProps = {
        id: `${name}-modal-label`,
    };
    if (title) {
        modalProps['aria-labelledby'] = `${name}-modal-label`;
    }
    if (label) {
        modalProps['aria-label'] = label;
    }
    return {
        modalProps,
        titleProps,
    };
}
exports.getModalAriaProps = getModalAriaProps;
function useCommonModalBehavior(modalProps) {
    const { onOpen = noop_1.default, onClose = noop_1.default, show = false } = modalProps;
    (0, ModalStackContext_1.useModalStackEntry)(show);
    const onOpenRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(onOpen);
    (0, react_1.useEffect)(() => {
        if (show) {
            onOpenRef.current();
        }
    }, [show, onOpenRef]);
    (0, react_1.useEffect)(() => {
        if (!show)
            return;
        function onKeyDown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                onClose();
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onClose, show]);
    return Object.assign(Object.assign({}, modalProps), { show,
        onOpen,
        onClose });
}
exports.useCommonModalBehavior = useCommonModalBehavior;
const CommonModal = props => {
    const { children, onClose = noop_1.default, show = true, className } = props;
    // @TODO make proper tab index for divs inside OR remove them
    return show ? (react_1.default.createElement(ModalOverlay_1.default, { className: className },
        react_1.default.createElement(ShadowOverlay_1.default, { onClick: onClose }, children))) : null;
};
exports.default = CommonModal;
//# sourceMappingURL=CommonModal.js.map